import { formatDate } from "./dateUtils";

const downloadBlob = (fileExtension, blob, filenamePrefix = "raport") => {
  const url = window.URL.createObjectURL(blob);

  const downloadLink = document.createElement("a");
  downloadLink.download = `${filenamePrefix}_${formatDate(new Date()).replace(
    /\s+/,
    "_"
  )}.${fileExtension}`;
  downloadLink.href = url;
  downloadLink.target = "_blank";
  document.body.appendChild(downloadLink);
  downloadLink.click();

  setTimeout(function() {
    document.body.removeChild(downloadLink);
  }, 500);
};

export { downloadBlob };
